var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgba(255, 255, 255, 0)",
      display: "block"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 50,
    r: 4,
    fill: "#e15b64"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "34;66;34",
    times: "0;0.5;1",
    dur: "1s",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "0s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 61.31370849898476,
    r: 4,
    fill: "#f47e60"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "34;66;34",
    times: "0;0.5;1",
    dur: "1s",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-0.125s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 66,
    r: 4,
    fill: "#f8b26a"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "34;66;34",
    times: "0;0.5;1",
    dur: "1s",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-0.25s",
    repeatCount: "indefinite"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 61.31370849898476,
    r: 4,
    fill: "#abbd81"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "34;66;34",
    times: "0;0.5;1",
    dur: "1s",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-0.375s",
    repeatCount: "indefinite"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 50,
    r: 4,
    fill: "#e15b64"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "34;66;34",
    times: "0;0.5;1",
    dur: "1s",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-0.5s",
    repeatCount: "indefinite"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 38.68629150101524,
    r: 4,
    fill: "#f47e60"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "34;66;34",
    times: "0;0.5;1",
    dur: "1s",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-0.625s",
    repeatCount: "indefinite"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 34,
    r: 4,
    fill: "#f8b26a"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "34;66;34",
    times: "0;0.5;1",
    dur: "1s",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-0.75s",
    repeatCount: "indefinite"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 38.68629150101523,
    r: 4,
    fill: "#abbd81"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "34;66;34",
    times: "0;0.5;1",
    dur: "1s",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-0.875s",
    repeatCount: "indefinite"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.19ad116771b4268df3dc7b6de9d09cd7.svg";
export { ForwardRef as ReactComponent };